import React from 'react';
import {
    AutoSaveCheckboxOptions,
    AutoSaveColorSelector,
    AutoSaveContentEditable,
    AutoSaveCurrencyInput,
    AutoSaveDateTimePicker,
    AutoSaveDropdown,
    AutoSaveNumberPicker,
    AutoSaveRadio,
    AutoSaveTextArea,
    AutoSaveTextInput,
    AutoSaveToggle
} from "components/forms/AutoSaveFormFields/index";
import PrizeImagePicker from 'hoc/PrizeImagePicker';

import AutoSaveResourceDropdown from "components/forms/AutoSaveFormFields/AutoSaveResourceDropdown";

export default {
    'text': (props) => <AutoSaveTextInput fieldLabel={props.label}
                                          name={props.name}
                                          labelKey={props.labelKey}
                                          placeholderKey={props.placeholderKey}
                                          helpContent={props.helpContent}
                                          helpHeader={props.helpHeader}
                                          showExtraContent={props.showExtraContent}
                                          extraContent={props.extraContent}
                                          required={props.required}
                                          defaultValue={props.value}
                                          onValueChanged={props.onValueChanged}
                                          isSaving={props.isSaving}
                                          errors={props.errors}
                                          savedField={props.savedField}
                                          onPersistValue={props.onValueChanged}/>,

    'textarea': (props) => <AutoSaveTextArea fieldLabel={props.label}
                                             name={props.name}
                                             labelKey={props.labelKey}
                                             placeholderKey={props.placeholderKey}
                                             helpContent={props.helpContent}
                                             helpHeader={props.helpHeader}
                                             showExtraContent={props.showExtraContent}
                                             extraContent={props.extraContent}
                                             required={props.required}
                                             defaultValue={props.value}
                                             onValueChanged={props.onValueChanged}
                                             isSaving={props.isSaving}
                                             errors={props.errors}
                                             savedField={props.savedField}
                                             onPersistValue={props.onValueChanged}/>,

    'contenteditable': (props) => <AutoSaveContentEditable fieldLabel={props.label}
                                                           name={props.name}
                                                           labelKey={props.labelKey}
                                                           placeholderKey={props.placeholderKey}
                                                           helpContent={props.helpContent}
                                                           helpHeader={props.helpHeader}
                                                           showExtraContent={props.showExtraContent}
                                                           extraContent={props.extraContent}
                                                           required={props.required}
                                                           defaultValue={props.value}
                                                           forceValidation={props.forceValidation}
                                                           validatingField={props.validatingField}
                                                           onValueChanged={props.onValueChanged}
                                                           isSaving={props.isSaving}
                                                           errors={props.errors}
                                                           savedField={props.savedField}
                                                           onPersistValue={props.onValueChanged} />,

    'number': (props) => <AutoSaveNumberPicker fieldLabel={props.label}
                                               name={props.name}
                                               labelKey={props.labelKey}
                                               placeholderKey={props.placeholderKey}
                                               min={props.min}
                                               max={props.max}
                                               helpContent={props.helpContent}
                                               helpHeader={props.helpHeader}
                                               showExtraContent={props.showExtraContent}
                                               extraContent={props.extraContent}
                                               required={props.required}
                                               defaultValue={props.value}
                                               onValueChanged={props.onValueChanged}
                                               isSaving={props.isSaving}
                                               errors={props.errors}
                                               savedField={props.savedField}
                                               validationRules={props.validationRules}
                                               onPersistValue={props.onValueChanged} />,

    'checkbox': (props) => <AutoSaveCheckboxOptions fieldLabel={props.label}
                                                    name={props.name}
                                                    labelKey={props.labelKey}
                                                    placeholderKey={props.placeholderKey}
                                                    options={props.options}
                                                    colCount={props.colCount}
                                                    helpContent={props.helpContent}
                                                    helpHeader={props.helpHeader}
                                                    showExtraContent={props.showExtraContent}
                                                    extraContent={props.extraContent}
                                                    required={props.required}
                                                    defaultValue={props.value}
                                                    onValueChanged={props.onValueChanged}
                                                    isSaving={props.isSaving}
                                                    errors={props.errors}
                                                    savedField={props.savedField}
                                                    onPersistValue={props.onValueChanged}/>,

    'toggle': (props) => <AutoSaveToggle fieldLabel={props.label}
                                         name={props.name}
                                         labelKey={props.labelKey}
                                         placeholderKey={props.placeholderKey}
                                         helpContent={props.helpContent}
                                         helpHeader={props.helpHeader}
                                         showExtraContent={props.showExtraContent}
                                         extraContent={props.extraContent}
                                         required={props.required}
                                         options={props.options}
                                         defaultValue={props.value}
                                         onValueChanged={props.onValueChanged}
                                         isSaving={props.isSaving}
                                         errors={props.errors}
                                         savedField={props.savedField}
                                         onPersistValue={props.onValueChanged}/>,

    'dropdown': (props) => <AutoSaveDropdown fieldLabel={props.label}
                                             name={props.name}
                                             labelKey={props.labelKey}
                                             placeholderKey={props.placeholderKey}
                                             options={props.options}
                                             helpContent={props.helpContent}
                                             helpHeader={props.helpHeader}
                                             showExtraContent={props.showExtraContent}
                                             extraContent={props.extraContent}
                                             required={props.required}
                                             defaultValue={props.value}
                                             onValueChanged={props.onValueChanged}
                                             isSaving={props.isSaving}
                                             errors={props.errors}
                                             savedField={props.savedField}
                                             onPersistValue={props.onValueChanged}/>,

    'datetime': (props) => <AutoSaveDateTimePicker fieldLabel={props.label}
                                                   timeSnap={props.timeSnap}
                                                   lang={props.lang}
                                                   name={props.name}
                                                   disabled={props.disabled}
                                                   labelKey={props.labelKey}
                                                   placeholderKey={props.placeholderKey}
                                                   helpContent={props.helpContent}
                                                   helpHeader={props.helpHeader}
                                                   showExtraContent={props.showExtraContent}
                                                   extraContent={props.extraContent}
                                                   required={props.required}
                                                   options={props.options}
                                                   defaultValue={props.value}
                                                   onValueChanged={props.onValueChanged}
                                                   isSaving={props.isSaving}
                                                   errors={props.errors}
                                                   savedField={props.savedField}
                                                   onPersistValue={props.onValueChanged} />,

    'currency': (props) => <AutoSaveCurrencyInput fieldLabel={props.label}
                                                  name={props.name}
                                                  labelKey={props.labelKey}
                                                  placeholderKey={props.placeholderKey}
                                                  helpContent={props.helpContent}
                                                  helpHeader={props.helpHeader}
                                                  showExtraContent={props.showExtraContent}
                                                  extraContent={props.extraContent}
                                                  required={props.required}
                                                  options={props.options}
                                                  defaultValue={props.value}
                                                  onValueChanged={props.onValueChanged}
                                                  isSaving={props.isSaving}
                                                  errors={props.errors}
                                                  savedField={props.savedField}
                                                  onPersistValue={props.onValueChanged} />,

    'color': (props) => <AutoSaveColorSelector fieldLabel={props.label}
                                               name={props.name}
                                               labelKey={props.labelKey}
                                               placeholderKey={props.placeholderKey}
                                               helpContent={props.helpContent}
                                               helpHeader={props.helpHeader}
                                               showExtraContent={props.showExtraContent}
                                               extraContent={props.extraContent}
                                               required={props.required}
                                               options={props.options}
                                               defaultValue={props.value}
                                               onValueChanged={props.onValueChanged}
                                               isSaving={props.isSaving}
                                               errors={props.errors}
                                               savedField={props.savedField}
                                               onPersistValue={props.onValueChanged}/>,

    'radio': (props) => <AutoSaveRadio fieldLabel={props.label}
                                       name={props.name}
                                       labelKey={props.labelKey}
                                       placeholderKey={props.placeholderKey}
                                       options={props.options}
                                       colCount={props.colCount}
                                       helpContent={props.helpContent}
                                       helpHeader={props.helpHeader}
                                       showExtraContent={props.showExtraContent}
                                       extraContent={props.extraContent}
                                       required={props.required}
                                       defaultValue={props.value}
                                       onValueChanged={props.onValueChanged}
                                       isSaving={props.isSaving}
                                       errors={props.errors}
                                       savedField={props.savedField}
                                       onPersistValue={props.onValueChanged}/>,

    'yesnoradio': (props) => <AutoSaveRadio fieldLabel={props.label}
                                            name={props.name}
                                            options={[
                                              {text: 'Yes', value: true},
                                              {text: 'No', value: false}
                                            ]}
                                            labelKey={props.labelKey}
                                            placeholderKey={props.placeholderKey}
                                            helpContent={props.helpContent}
                                            helpHeader={props.helpHeader}
                                            showExtraContent={props.showExtraContent}
                                            extraContent={props.extraContent}
                                            required={props.required}
                                            defaultValue={(
                                              typeof props.defaultValue === typeof true
                                                ? props.defaultValue
                                                : props.value
                                            )}
                                            forceValidation={props.forceValidation}
                                            validatingField={props.validatingField}
                                            onValueChanged={props.onValueChanged}
                                            isSaving={props.isSaving}
                                            errors={props.errors}
                                            savedField={props.savedField}
                                            onPersistValue={props.onValueChanged}/>,

    'image': PrizeImagePicker,
    // we pass all the same args as dropdown (above) along with args for resource selection
    'resourceDropdown': (props) => <AutoSaveResourceDropdown fieldLabel={props.label}
                                       name={props.name}
                                       labelKey={props.labelKey}
                                       placeholderKey={props.placeholderKey}
                                       options={props.options}
                                       helpContent={props.helpContent}
                                       helpHeader={props.helpHeader}
                                       showExtraContent={props.showExtraContent}
                                       extraContent={props.extraContent}
                                       required={props.required}
                                       defaultValue={props.value}
                                       onValueChanged={props.onValueChanged}
                                       isSaving={props.isSaving}
                                       errors={props.errors}
                                       savedField={props.savedField}
                                       onPersistValue={props.onValueChanged}
                                       
                                       resource={props.resource}
                                       resourceSortOptions={ props.resourceSortOptions }
                                       resourceFilter={ props.resourceFilter }
                                       itemTransformer={ props.itemTransformer }
                                       />,


};



// WEBPACK FOOTER //
// ./public/components/forms/Component Sets/AutoSaveComponents.js